import React from "react";
import { useNavigate } from "react-router-dom";

import styles from "../css/landing.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faArrowLeft,
  faUser,
  faHouse,
  faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

/**
 * Shared top bar used on every page.
 * Props:
 *  - title / subtitle: page heading text
 *  - userName: label shown in the user chip (defaults to "Admin")
 *  - showBack: show the Back button (default true)
 */
function Topbar({ title, subtitle, userName = "Admin", showBack = true }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const toggleSidebar = () => {
    window.dispatchEvent(new Event("kharis-toggle-sidebar"));
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <button
          className={styles.menuBtn}
          onClick={toggleSidebar}
          aria-label="Toggle menu"
        >
          <FontAwesomeIcon icon={faBars} />
        </button>

        {showBack && (
          <button
            className={styles.backBtn}
            onClick={() => navigate(-1)}
            aria-label="Go back"
            title="Back"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
            <span className={styles.backText}>Back</span>
          </button>
        )}

        <div className={styles.pageTitleWrap}>
          <h1 className={styles.pageTitle}>{title}</h1>
          {subtitle ? <p className={styles.pageSubtitle}>{subtitle}</p> : null}
        </div>
      </div>

      <div className={styles.headerRight}>
        <div className={styles.userChip} title={userName}>
          <span className={styles.userIcon}>
            <FontAwesomeIcon icon={faUser} />
          </span>
          <span className={styles.userText}>{userName}</span>
        </div>

        <button
          className={styles.iconBtn}
          onClick={() => navigate("/landing")}
          aria-label="Home"
          title="Home"
        >
          <FontAwesomeIcon icon={faHouse} />
        </button>

        <button
          className={`${styles.iconBtn} ${styles.dangerBtn}`}
          onClick={handleLogout}
          aria-label="Logout"
          title="Logout"
        >
          <FontAwesomeIcon icon={faArrowRightFromBracket} />
        </button>
      </div>
    </header>
  );
}

export default Topbar;
